import "./HomeHeaderSkeleton.scss";

export const HomeHeaderSkeleton = () => {
  return (
    <div className="home-header-skeleton-container">
      <div className="home-header-skeleton-header-row">
        <div className="home-header-skeleton-doctor-name pulse"></div>
        <div className="home-header-skeleton-doctor-search pulse"></div>
      </div>
    </div>
  );
};
